export default __webpack_public_path__ + "static/media/webDev.01f36591.svg";